module.exports = __webpack_public_path__ + "img/RU.e3b5d59c.png";